/**
 * HubApi.ts — Cliente da API do EnsinoSocial para o hub.
 *
 * Usado pra: descobrir se o usuario esta logado (chip do canto superior).
 * Reusa o endpoint `?a=logicbugs.api&op=quem-sou` que ja existe em prod —
 * a resposta e generica (id/nome/avatar) e serve pra qualquer jogo.
 *
 * Cookie de sessao tem domain=.ensinosocial.com.br + SameSite=Lax,
 * entao a sessao e compartilhada sem CORS-credentials magic.
 */

const HOST = location.hostname;

const API_BASE: string = (() => {
  if (HOST === 'localhost' || HOST === '127.0.0.1') {
    return 'http://localhost:8888';
  }
  return 'https://ensinosocial.com.br';
})();

export interface QuemSouResposta {
  logado: boolean;
  admin?: boolean;
  usuario?: { id: number; nome: string; avatar: string };
}

export interface JogoCatalogoApi {
  slug: string;
  titulo: string;
  descricao: string;
  url: string;
  icone: string;
  gradiente: string;
  status: 'estavel' | 'beta' | 'em-breve';
  meta: Array<{ icone: string; texto: string }>;
}

export class HubApi {
  /** URL pra login no monolito, com redirect de volta pro hub. */
  get loginUrl(): string {
    return `${API_BASE}/?a=auth.login&redirect=${encodeURIComponent(location.href)}`;
  }

  /**
   * Catalogo dinamico (?a=jogos.api&op=catalogo — jogo_catalogo do monolito,
   * migr 300). Lanca em erro: quem decide o fallback e o chamador (main.ts
   * renderiza a lista hardcoded de jogos.ts e segue a vida).
   */
  async catalogo(): Promise<JogoCatalogoApi[]> {
    const url = new URL(`${API_BASE}/`);
    url.searchParams.set('a', 'jogos.api');
    url.searchParams.set('op', 'catalogo');
    const r = await fetch(url.toString(), { method: 'GET', credentials: 'include' });
    if (!r.ok) throw new Error(`HTTP ${r.status}`);
    const data = (await r.json()) as { sucesso?: boolean; jogos?: JogoCatalogoApi[] };
    if (!data.sucesso || !Array.isArray(data.jogos) || data.jogos.length === 0) {
      throw new Error('catalogo vazio');
    }
    return data.jogos;
  }

  async quemSou(): Promise<QuemSouResposta> {
    try {
      const url = new URL(`${API_BASE}/`);
      url.searchParams.set('a', 'logicbugs.api');
      url.searchParams.set('op', 'quem-sou');
      const r = await fetch(url.toString(), {
        method: 'GET',
        credentials: 'include',
      });
      if (!r.ok) throw new Error(`HTTP ${r.status}`);
      return (await r.json()) as QuemSouResposta;
    } catch {
      return { logado: false };
    }
  }
}
